/* eslint-disable @typescript-eslint/no-explicit-any */
import { combineReducers, Action as ReduxAction } from 'redux';
import { ThunkAction as ReduxThunkAction } from 'redux-thunk';

import settings from '../../common/reducers/settings';
import experiments from '../../common/reducers/experiments';
import roles from '../../common/reducers/roles';
import members from '../../common/state/members/reducer';
import membersPage from '../../common/state/members-page/reducer';
import site from '../../common/state/site/reducer';
import badgesDefinitions from '../../common/reducers/badges-definitions';

export type MembersState = any;

export interface Action extends ReduxAction {
  payload: any;
}

export type ThunkAction<R = void> = ReduxThunkAction<R, MembersState, {}>;

export const reducer = combineReducers<MembersState>({
  settings,
  members,
  membersPage,
  roles,
  experiments,
  site,
  badgesDefinitions,
});
